
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WebsiteCreationAction, WebsiteDeletionAction } from '@/services/Website/interfaces';
import { WebsiteMigrationAction } from '@/services/WebsiteMigrations/interfaces';

@Component({
  mixins: [Themeable],
})
export default class ChangeActionStatusDialog extends Vue {
  @Prop() public action!: WebsiteCreationAction | WebsiteMigrationAction | WebsiteDeletionAction;

  public visible: boolean = true;

  public statuses: { name: string }[] = [
    { status: 'failed' },
    { status: 'retry' },
    { status: 'done' },
    { status: 'rolled back' },
    { status: 'cancelled' },
  ];

  public selectedStatus: string = '';

  public transformKebabCase(str: string): string {
    return str
      .replaceAll('-', ' ')
      .replaceAll('_', ' ')
      .toUpperCase();
  }

  public get valid(): boolean {
    return !!this.selectedStatus && this.selectedStatus !== this.action.status;
  }

  public changeStatus(): void {
    this.$emit('changeStatus', this.action.id, this.selectedStatus);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
    this.visible = false;
  }
}
